import DOMPurify from 'dompurify';

// 連絡帳・お知らせ本文には generateYoutubeThumbnail で生成された YouTube 埋め込み(iframe)が
// 保存されているため、この prefix で始まる src の iframe のみ許可する。
const YOUTUBE_EMBED_SRC_PREFIX = 'https://www.youtube.com/embed/';

const setRelNoopener = (node: Element): void => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
};

// YouTube 埋め込みは iframe を許可する例外なので、再生に必要な権限だけの sandbox で閉じ込める
// (権限を絞りすぎると player の JS が動かず再生できない)。
// afterSanitizeAttributes で setAttribute した値は ADD_ATTR 無しでも保持される。
const setYoutubeIframeSandbox = (node: Element): void => {
  if (node.tagName === 'IFRAME' && (node.getAttribute('src') || '').startsWith(YOUTUBE_EMBED_SRC_PREFIX)) {
    node.setAttribute(
      'sandbox',
      'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-top-navigation'
    );
  }
};

// iframe は YouTube 埋め込みのみ許可し、それ以外の src を持つ iframe は除去する。
const removeNonYoutubeIframe = (node: Node, data: { tagName: string }): void => {
  if (data.tagName === 'iframe') {
    const src = (node as Element).getAttribute('src') || '';
    if (!src.startsWith(YOUTUBE_EMBED_SRC_PREFIX)) {
      node.parentNode?.removeChild(node);
    }
  }
};

export function sanitizeRichTextHtml(content: string): string {
  DOMPurify.addHook('afterSanitizeAttributes', setRelNoopener);
  DOMPurify.addHook('afterSanitizeAttributes', setYoutubeIframeSandbox);
  DOMPurify.addHook('uponSanitizeElement', removeNonYoutubeIframe);
  try {
    return DOMPurify.sanitize(content, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'colwidth'],
    });
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes', setRelNoopener);
    DOMPurify.removeHook('afterSanitizeAttributes', setYoutubeIframeSandbox);
    DOMPurify.removeHook('uponSanitizeElement', removeNonYoutubeIframe);
  }
}
